var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.46798,
    y: 0.46798,
    width: 39.064,
    height: 39.064,
    rx: 7.95565,
    fill: "#150B3D",
    stroke: "white",
    strokeWidth: 0.93596
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.0278,
    height: 14.9579,
    rx: 2.5139,
    transform: "matrix(0.654753 0.755843 -0.73635 0.676601 18.1255 7.11118)",
    fill: "#0073FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0084,
    y: 19.4827,
    width: 4.5968,
    height: 8.35024,
    rx: 2.2984,
    transform: "rotate(48.2616 16.0084 19.4827)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62873,
    height: 16.7081,
    rx: 2.31437,
    transform: "matrix(0.654753 0.755843 -0.73635 0.676601 29.192 17.705)",
    fill: "#CF95FB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarden);
export default __webpack_public_path__ + "static/media/carden.dd968b75384a7d4fb803b3e3618df9fe.svg";
export { ForwardRef as ReactComponent };